<template>
  <div>
    <div id="outrights">
      <header-menu :show-hours="false" />
      <sports-header
        v-if="showSportsHeader"
        :limit="limit"
        :selected-provider-id="selectedProviderId"/>
      <div
        class="sport"
        :class="'sport-' + selectedSport.providerId"
        v-if="selectedSport">
        <div
          class="back-button"
          v-go-back>
          <i class="n-i n-i-arrow-left"/>
        </div>
        {{ selectedSport.name }} \ {{ getTranslation('sportsbook.outrights_title') }}
      </div>
      <scroller v-if="selectedSport">
        <div
          v-max-height="{
          el: ['.header-menu', '.sports-header', '.footer', '.sport'], offset: 30 }">
          <div class="categories-wrapper">
            <div class="categories">
              <div class="categories">
                <div
                  class="category"
                  v-for="category in tree"
                  :key="category.id">

                  <div class="category-header">
                    <div class="flag-wrapper">
                      <div :class="['flag', getFlag(category)]" />
                    </div>
                    <div>{{ category.name }}</div>
                  </div>

                  <div class="tournaments">
                    <router-link
                      tag="div"
                      class="tournament-wrapper"
                      v-for="tour in category.tournaments"
                      :to="{
                        name: 'OutrightsTournament',
                        params: {
                          tournamentId: tour.id,
                          sportId: selectedSport.id
                        }
                      }"
                      :key="tour.id">
                      <div class="tournament">
                        {{ tour.name }}
                      </div>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </scroller>
    </div>
  </div>
</template>
<script>
import Moment from 'moment';
import HeaderMenu from '../../shared/header-menu/HeaderMenu.vue';
import SportsHeader from '../../shared/sports-header/SportsHeader.vue';

export default {
  components: {
    HeaderMenu,
    SportsHeader,
  },
  computed: {
    selectedProviderId() {
      return parseInt(this.$route.params.sportId, 10) || false;
    },
    selectedSport() {
      return this.$store.getters.getActiveOutrightsSport;
    },
    sports() {
      return this.$store.getters.getOutrightsSports;
    },
    categories() {
      return this.$store.getters.getOutrightsCategories;
    },
    tournaments() {
      return this.$store.getters.getOutrightsTournaments;
    },
    showBetslip() {
      return this.$store.getters.getBetslipShow;
    },
    tree() {
      let categories = [];
      let tournaments = [];
      if (this.selectedSport) {
        categories = this.categories.filter(item => item.idSport === this.selectedSport.id);
        tournaments = this.tournaments.filter(item => item.idSport === this.selectedSport.id);
      }

      categories.forEach((item) => {
        const category = item;
        category.tournaments = _.sortBy(
          tournaments.filter(tour => tour.idCategory === category.id),
          ['position'],
        );
      });
      return categories;
    },
    limit() {
      return this.$store.getters.getCompanyConfig.maxSports;
    },
    showSportsHeader() {
      return this.sports && this.sports.length && this.selectedProviderId;
    },
  },
  methods: {
    getTranslation(key) {
      return this.$store.getters.getTranslation(key);
    },
    getFlag(category) {
      return `flag-${_.toLower(category.isoName) || 'int'}`;
    },
  },
  mounted() {
    const dateFormat = 'YYYY-MM-DD HH:mm:ss';
    const startDate = new Moment();
    const endDate = new Moment();
    endDate.endOf('day');
    this.$store.dispatch('fetchOutrightsMeta', {
      params: {
        is_outright: 1,
        start_date: Moment.utc(startDate).format(dateFormat),
        end_date: Moment.utc(endDate).format(dateFormat),
      },
    });
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../scss/default/modules/outrights';
</style>
